import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_c8b9c288";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_c8b9c288" };
/** script content **/
require("./checkbox-group.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findexc8b9c288%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fcheckbox-group%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_c8b9c288"],
    ctorType: "component",
    outputPath: "components/indexc8b9c288/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-checkbox': getComponent(require("../checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
